import { Fragment } from 'react';

import splitFormattedText from 'shared/presentation/helpers/splitFormattedText';

interface IFormattedTextProps {
  text?: string | null;
}

export default function FormattedText({ text }: IFormattedTextProps) {
  return (
    <>
      {splitFormattedText(text).map((part, index) =>
        part.highlight ? (
          // eslint-disable-next-line react/no-array-index-key
          <strong key={index}>{part.text}</strong>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
